var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuAllshare = function SvgIconMenuAllshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.126,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "m12.304 5.737-.549-1.091-6.551 3.606.549 1.091Zm-7.1 6.011 6.551 3.606.549-1.092-6.551-3.606Z",
    "data-name": "Path 5788"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M14.378 7.5a3.75 3.75 0 1 0-3.75-3.75 3.75 3.75 0 0 0 3.75 3.75m0-5.625A1.875 1.875 0 1 1 12.5 3.75a1.875 1.875 0 0 1 1.878-1.875M3.75 6.25A3.75 3.75 0 1 0 7.5 10a3.75 3.75 0 0 0-3.75-3.75m0 5.625A1.875 1.875 0 1 1 5.625 10a1.875 1.875 0 0 1-1.875 1.875m10.628.625a3.75 3.75 0 1 0 3.75 3.75 3.75 3.75 0 0 0-3.75-3.75m0 5.625a1.875 1.875 0 1 1 1.875-1.875 1.876 1.876 0 0 1-1.875 1.875",
    "data-name": "Path 5789"
  })));
};
export default SvgIconMenuAllshare;